import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import ElementTypeTableService from '../service/ElementTypeTableService';

const config = {
	key: 'elementTypeTable',
	topic: 'elementType',
	text: 'Element Type',
	service: ElementTypeTableService,
	editFormState: item => `/element-type/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['modify', 'delete'],
	columns: [
		{
			key: 'name',
			type: 'text',
			sortable: true,
			disablePadding: false
		}
	]
};

function ElementTypeTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('elementTypeTable', reducer('elementTypeTable'))(ElementTypeTable);
